import useAxios from 'axios-hooks';
import {
  ICompletedSection,
  IIntroduction,
  IOtherDescription,
  IRemark,
} from './utils';
import { IName } from './MasterData';
import { IUploadImage } from './UploadImage';

export enum StakeholderType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

interface IBasicSubsection {
  introduction?: IIntroduction;
  remark?: IRemark;
  otherDescription?: IOtherDescription[];
}

export interface IBasicStakeholderAnalysis {
  introduction?: IIntroduction;
  additionalDescriptionTh: string;
  additionalDescriptionEn: string;
  remark?: IRemark;
  completedSection?: ICompletedSection;
  assets?: Array<IUploadImage>;
}

export interface IBasicStakeholderGroup {
  stakeholderType: StakeholderType;
  expectationDescriptionTh: string;
  expectationDescriptionEn: string;
  respondingToExpectationTh?: string;
  respondingToExpectationEn?: string;
}

export interface IBusinessValueChain extends IBasicSubsection {
  id?: number;
  descriptionTh: string;
  descriptionEn: string;
  assets?: Array<IUploadImage>;
}

export interface IImpactsOnStakeholdersQuery extends IBasicSubsection {
  id?: number;
  businessValueChain?: IBusinessValueChain;
  stakeholderAnalysis?: IStakeholderAnalysisQuery;
}

export interface IStakeholderAnalysisQuery extends IBasicStakeholderAnalysis {
  id: number;
  stakeholderGroups: Array<IStakeholderGroupQuery>;
}

export interface IStakeholderGroupQuery extends IBasicStakeholderGroup {
  id: number;
  stakeholders: Array<IMasterDataQuery>;
  otherStakeholders?: Array<IOtherQuery>;
  communicationActivities?: Array<IMasterDataQuery>;
  otherCommunicationActivities?: Array<IOtherQuery>;
}

export interface IMasterDataQuery extends IName {
  id: number;
  infoCategoryMasterDataId: number;
  infoCategory: string;
  sequence: number;
}

export interface IOtherQuery extends IName {
  id: number;
}

export interface IImpactsOnStakeholdersMutation extends IBasicSubsection {
  id?: number;
  businessValueChain?: IBusinessValueChain;
  stakeholderAnalysis?: IStakeholderAnalysisMutation;
}

export interface IStakeholderAnalysisMutation
  extends IBasicStakeholderAnalysis {
  stakeholderGroups: Array<IStakeholderGroupMutation>;
}

export interface IStakeholderGroupMutation extends IBasicStakeholderGroup {
  stakeholders: Array<IStakeholderMutation>;
  otherStakeholders?: Array<IName>;
  communicationActivities?: Array<ICommunicationActivityMutation>;
  otherCommunicationActivities?: Array<IName>;
}

export interface IStakeholderMutation {
  infoCategoryMasterDataId: number;
}

export interface ICommunicationActivityMutation {
  infoCategoryMasterDataId: number;
}

export const useSaveImpactsOnStakeholders = (
  reportId?: string,
  payload?: IImpactsOnStakeholdersMutation
) => {
  return useAxios<IImpactsOnStakeholdersQuery>(
    {
      url: `/impacts-on-stakeholders`,
      method: 'POST',
      params: { reportId },
      data: payload,
    },
    { manual: true }
  );
};

export const useGetImpactsOnStakeholders = (reportId?: string) => {
  return useAxios<IImpactsOnStakeholdersQuery>(
    `/impacts-on-stakeholders/${reportId}`
  );
};

export const useGetImpactsOnStakeholdersOneReport = (
  reportId: string,
  companyScpId: number,
  asOfYear: number
) => {
  return useAxios(
    {
      url: `/impacts-on-stakeholders/${reportId}/one-report`,
      method: 'POST',
      data: { companyScpId, asOfYear },
    },
    { manual: true }
  );
};
